/**
 * ADMIN MODULE — Paperclip connection status hook.
 * Polls getPaperclipHealth() through paperclipClient (never the API directly)
 * and exposes a simple online/offline state for nav dots and warning banners.
 */

import { useEffect, useState } from "react";
import { getPaperclipHealth } from "../utils/paperclipClient.js";

// status: 'pending' | 'online' | 'offline'
export function usePaperclipHealth(pollMs = 30000) {
  const [status, setStatus] = useState("pending");

  useEffect(() => {
    let alive = true;
    async function check() {
      const { error } = await getPaperclipHealth();
      if (!alive) return;
      setStatus(error ? "offline" : "online");
    }
    check();
    const id = setInterval(check, pollMs);
    return () => { alive = false; clearInterval(id); };
  }, [pollMs]);

  return status;
}
